import React from 'react';
import refresh from 'Assets/img/refresh.svg';
import PropTypes from 'prop-types';
import ReactTimeAgo from 'react-time-ago';
import './RefreshTimeBox.scss';
import JavascriptTimeAgo from 'javascript-time-ago';
// The desired locales.
import en from 'javascript-time-ago/locale/en';

// Initialize the desired locales.
JavascriptTimeAgo.locale(en);

const RefreshTimeBox = ({ timeBoxData, refreshTimeFeed, version }) => {
  if(version == 2) {
    return (
      <div className="time-box-container-v2">
        <span className="time-ago-v2"> {timeBoxData.text} <ReactTimeAgo date={timeBoxData.date} />. </span>
        <div className="icon-v2"><img src={refresh} className="image" alt="refresh" style={{padding:"5px 5px"}} onClick={refreshTimeFeed} /></div>
      </div>
    );
  } else {
    return (
      <div className="refresh-time-box">
        <div className="image-div"><img src={refresh} className="image" alt="refresh" style={{padding:"5px 5px"}} onClick={refreshTimeFeed} /></div>
        <p className="react-time-ago"> {timeBoxData.text} <ReactTimeAgo date={timeBoxData.date} />. </p>
      </div>
    );
  }
  
};
RefreshTimeBox.propTypes = {
  timeBoxData: PropTypes.object.isRequired,
};

RefreshTimeBox.defaultProps = {
  timeBoxData: {},

};
export default RefreshTimeBox;
